export default function ServiceCard({ icon: Icon, title, description }) {
  return (
    <div className="w-full flex justify-center">
      <div
        className="relative p-6 w-full h-48 md:h-56 flex flex-col items-center justify-center gap-3 transition-transform card-soft bg-brand-white"
        style={{
          color: "var(--text)",
        }}
      >
        <div className="flex justify-center flex-shrink-0">
          <Icon className="w-10 h-10" style={{ color: "var(--brand-red)" }} />
        </div>

        <div className="px-2 text-center flex flex-col items-center justify-center">
          <h3 className="font-bold text-md leading-tight" style={{ color: "var(--text)" }}>
            {title}
          </h3>
          <p className="text-sm mt-2 leading-snug" style={{ color: "var(--muted)" }}>
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}
